module.exports = __webpack_public_path__ + "static/media/Малошенко Анжела Геннадьевна Кибитень. Звезда полей Красноярский край-4.png";